import { render, staticRenderFns } from "./CategoryContentSection.vue?vue&type=template&id=0681e7fe&"
import script from "./CategoryContentSection.vue?vue&type=script&lang=js&"
export * from "./CategoryContentSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports